import {
	ADD_BUDGET,
	UPDATE_BUDGET,
	DELETE_BUDGET,
	GET_BUDGET_LIST,
	UPDATE_SP_BUDGET,
} from '../constant';
import {
	getBudgetsApi,
	addBudgetApi,
	updateBudgetApi,
	deleteBudgetApi,
	submitBudgetApi,
} from '../../api';

export const getBudgets = (data) => ({
	type: GET_BUDGET_LIST,
	data,
});

export const addBudget = (data) => ({
	type: ADD_BUDGET,
	data,
});

export const updateBudget = (data) => ({
	type: UPDATE_BUDGET,
	data,
});
export const updateSPBudget = (data) => ({
	type: UPDATE_SP_BUDGET,
	data,
});
export const deleteBudget = (data) => ({
	type: DELETE_BUDGET,
	data,
});

export const getBudgetsAsync = (params) => {
	const pageSize = 15;
	params = { ...params, pageSize };
	return (dispatch) => {
		return getBudgetsApi(params)
			.then((data) => {
				if (data.errorCode.trim().length === 0) {
					// (data.value as any) = null;
					const totalCount = (data.value as any)?.total ?? 0;
					const totalpage =
						parseInt(parseInt(totalCount) / pageSize + '') +
						(totalCount % pageSize > 0 ? 1 : 0);
					console.log('::::::::::::::::::', totalpage);
					dispatch(
						getBudgets({
							data: (data.value as any)?.data ?? [],
							total: totalpage,
						})
					);
				} else {
					console.error(`${data.errorCode}:: ${data.errorMessage}`);
				}
			})
			.catch((error) => {
				throw error;
			});
	};
};

export const addBudgetAsync = (data) => async (dispatch) => {
	try {
		const response = await addBudgetApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(addBudget(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateBudgetAsync = (data) => async (dispatch) => {
	try {
		const response = await updateBudgetApi(data);
		if (response.errorCode.trim().length === 0) {
			console.log(':::::::::::updateBudgetAsync', response.value);
			dispatch(updateBudget(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteBudgetAsync = (data) => async (dispatch) => {
	try {
		const response = await deleteBudgetApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(deleteBudget(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

export const submitBudgetAsync = (data) => async (dispatch) => {
	try {
		const response = await submitBudgetApi(data);
		if (response.errorCode.trim().length === 0) {
			console.log(':::::::::::submitBudgetAsync', response.value);
			dispatch(updateBudget(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

export const submitNewBudgetAsync = (data) => async (dispatch) => {
	try {
		const response = await submitBudgetApi(data);
		if (response.errorCode.trim().length === 0) {
			console.log(':::::::::::submitBudgetAsync', response.value);
			dispatch(addBudget(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};
